import React, { useState } from 'react';
import { PropTypes } from 'prop-types';
import { useParams } from 'react-router-dom';
import { Button, Field, Loader } from '@itds/elements/index.js';

import ImgExpansionCard from '@brokerage/components/ImgExpansionCard';

import { Api } from '@brokerage/utils/Api';

const BuildAssets = ({ loadApp, mobile_app }) => {
  const params = useParams();
  const { guid } = params;

  const default_file_fields = {
    background: null,
    contact_us_icon: null,
    default_h_screen: null,
    default_portrait_1366_screen: null,
    default_portrait_screen: null,
    default_screen: null,
    etickets_icon: null,
    icon_background: null,
    icon_dpi: null,
    icon_foreground: null,
    icon_notification_default: null,
    icon: null,
    life_quotes_icon: null,
    links_icon: null,
    logo: null,
    logout_icon: null,
    menu_logo: null,
    my_sales_rep_icon: null,
    needs_calculator_icon: null,
    notifications_icon: null,
    privacy_policy_icon: null,
    tos_icon: null,
    uwp_icon: null,
    videos_icon: null,
    website_icon: null,
    webview1_icon: null,
    webview2_icon: null,
    webview3_icon: null,
    webview4_icon: null,
    webview5_icon: null,
    webview6_icon: null
  };
  const [loading, setLoading] = useState(false);
  const [file_fields, setFileFields] = useState(default_file_fields);

  const _handleChangeFile = (label, file) => {
    setFileFields({ ...file_fields, [label]: file });
  };

  const _handleSave = () => {
    setLoading(true);
    Api.updateMobileApp(guid, file_fields).then(() => {
      loadApp();
      window.scrollTo(0, 0);
      setLoading(false);
      setFileFields(default_file_fields);
    });
  };

  return loading ? (
    <Loader />
  ) : (
    <>
      <Field label='App Icons'>
        {[
          'icon',
          'icon_dpi',
          'icon_foreground',
          'icon_background',
          'icon_notification_default'
        ].map(name => {
          return (
            <ImgExpansionCard
              data={mobile_app[name]}
              file={file_fields[name]}
              key={name}
              label={name}
              onChange={_handleChangeFile.bind(null, name)}
            />
          );
        })}
      </Field>

      <Field label='Splash Screens'>
        {[
          'default_screen',
          'default_h_screen',
          'default_portrait_screen',
          'default_portrait_1366_screen'
        ].map(name => {
          return (
            <ImgExpansionCard
              data={mobile_app[name]}
              file={file_fields[name]}
              key={name}
              label={name}
              onChange={_handleChangeFile.bind(null, name)}
            />
          );
        })}
      </Field>

      <Field label='Branding'>
        {['logo', 'menu_logo', 'background'].map(name => {
          return (
            <ImgExpansionCard
              data={mobile_app[name]}
              file={file_fields[name]}
              key={name}
              label={name}
              onChange={_handleChangeFile.bind(null, name)}
            />
          );
        })}
      </Field>

      <Field label='Menu Icons'>
        {[
          'notifications_icon',
          'needs_calculator_icon',
          'etickets_icon',
          'life_quotes_icon',
          'links_icon',
          'my_sales_rep_icon',
          'uwp_icon',
          'videos_icon',
          'website_icon',
          'webview1_icon',
          'webview2_icon',
          'webview3_icon',
          'webview4_icon',
          'webview5_icon',
          'webview6_icon',
          'contact_us_icon',
          'privacy_policy_icon',
          'tos_icon',
          'logout_icon'
        ].map(name => {
          return (
            <ImgExpansionCard
              data={mobile_app[name]}
              file={file_fields[name]}
              key={name}
              label={name}
              onChange={_handleChangeFile.bind(null, name)}
            />
          );
        })}
      </Field>

      <Button inline={true} onClick={_handleSave}>
        Save
      </Button>
    </>
  );
};

BuildAssets.propTypes = {
  imageNames: PropTypes.array,
  loadApp: PropTypes.func,
  mobile_app: PropTypes.object
};

export default BuildAssets;
